import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { SVGIcon, arrowRotateCwIcon, downloadIcon, globeIcon, saveIcon, trackChangesEnableIcon } from '@progress/kendo-svg-icons';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CFFile } from '../../../models/attachments/cf-file';
import { CFDocumentToDisplay } from '../../../models/cf-document/cf-document-to-display';
import { CFEventToDisplay } from '../../../models/events/cf-event-to-display';
import { CustomNotificationService } from '../../../services/custom-notification.service';
import { CFDocumentStoreService } from '../../../services/documents/cf-document-store.service';
import { CustomMessagesService } from '../../../services/translation/custom-messages.service';
import { Constants } from '../../../util/constants';

@UntilDestroy()
@Component({
    selector: 'clfl-events-tab',
    templateUrl: './events-tab.component.html',
    styleUrls: ['./events-tab.component.scss']
})
export class EventsTabComponent implements OnInit, OnChanges {
    @Input()
    public events!: Array<CFEventToDisplay>;

    @Output() onRefresh: EventEmitter<void> = new EventEmitter();
    @Output() onFileDownload: EventEmitter<CFFile> = new EventEmitter();
    public refreshing = false;

    public arrowRotateCwIcon: SVGIcon = arrowRotateCwIcon;
    public downloadIcon: SVGIcon = downloadIcon;
    public globeIcon: SVGIcon = globeIcon;
    public trackChangesEnableIcon: SVGIcon = trackChangesEnableIcon;
    public saveIcon: SVGIcon = saveIcon;

    public document!: CFDocumentToDisplay;

    constructor(
        public documentStoreService: CFDocumentStoreService,
        private notificationService: CustomNotificationService,
        private messageService: CustomMessagesService
    ) {}

    ngOnInit(): void {
        this.documentStoreService.documentData$.pipe(untilDestroyed(this)).subscribe({
            next: (document) => (this.document = document)
        });
    }

    ngOnChanges(): void {
        this.refreshing = false;
    }

    public downloadFile(file: CFFile) {
        this.onFileDownload.emit(file);
    }

    public refreshFiles() {
        this.onRefresh.emit();
        this.refreshing = true;
    }

    public openGoogleMaps(selectedEvent: CFEventToDisplay) {
        const googleMapsUrl = `${Constants.GOOGLE_MAPS_URL}${selectedEvent.latitude},${selectedEvent.longitude}`;
        window.open(googleMapsUrl, '_blank');
    }

    public copyToClipboard(txId: string) {
        this.notificationService.success(this.messageService.translate('cf-event.notification.copiedTxId'));
    }

    public getSectionName(sectionId: string) {
        const documentSection = this.document.sections.find((section) => section.sectionId === sectionId);

        return documentSection ? documentSection.sectionName : '';
    }

    getStatusColor(status: string) {
        switch (status) {
            case 'Queued':
                return 'badge-validate';
            case 'Running':
                return 'badge-progress';
            case 'Completed':
                return 'badge-success';
            case 'Failed':
                return 'badge-danger';
        }

        return '';
    }
}
